import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import {
  Button,
  Col,
  DatePicker,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  TimePicker
} from 'hljd'
import Upload from './Upload'
import Style from './style.module.less'
import { observer } from 'mobx-react'
import { NO_ORDER_TAKING, TYPE_STATUS } from '../constant'
import moment from 'moment'
import { isSanDaTeam, isSiYiTeam } from '@util'
import MemberSelect, { MEMBER_AUDIT_STATUS } from '@common/MemberSelect'

const Item = Form.Item

@Form.create()
@observer
export default class extends Component {
  componentDidMount() {
    const { store, form } = this.props
    store.setForm(form)
  }
  render() {
    const { store, form } = this.props
    const { getFieldDecorator, getFieldValue } = form
    const {
      modalVisable,
      scheduleSlot,
      groupMembers,
      onSave,
      hideModalVisable,
      onDeleteSubmit
    } = store
    const slot = getFieldValue('slot')
    const id = getFieldValue('id')

    return (
      <Modal
        visible={modalVisable}
        closable={false}
        cancelText="删除"
        okText="保存"
        wrapClassName={Style.form}
        footer={
          <>
            <Button onClick={hideModalVisable}>取消</Button>
            {!!id && <Button onClick={onDeleteSubmit}>删除</Button>}
            <Button type="primary" onClick={onSave}>
              保存
            </Button>
          </>
        }
      >
        <Form labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
          {getFieldDecorator('id')(<Input type="hidden" />)}
          <Row gutter={40}>
            <Col span={12}>
              <Item label="日期">
                {getFieldDecorator('date', {
                  initialValue: moment(),
                  rules: [
                    {
                      required: true,
                      message: '请选择日期'
                    }
                  ]
                })(
                  <DatePicker
                    style={{ width: '100%' }}
                    placeholder="请选择日期"
                  />
                )}
              </Item>
            </Col>

            <Col span={12}>
              <Item label="时段">
                {getFieldDecorator('slot', {
                  // initialValue: '',
                  rules: [
                    {
                      required: true,
                      message: '请选择时段'
                    }
                  ]
                })(
                  <Select style={{ width: '100%' }}>
                    {scheduleSlot
                      .filter(item => item.id != -1)
                      .map((item, index) => {
                        return (
                          <Select.Option key={item.id} value={item.id}>
                            {item.name}
                          </Select.Option>
                        )
                      })}
                  </Select>
                )}
              </Item>
            </Col>
            {isSanDaTeam() && (
              <Col span={12}>
                <Item label="执行人">
                  {getFieldDecorator('merchantId', {
                    // initialValue: '',
                    rules: [
                      {
                        required: true,
                        message: '请选择执行人'
                      }
                    ]
                  })(
                    <Select style={{ width: '100%' }}>
                      {groupMembers.filter(item => item.id).map(item => {
                        return (
                          <Select.Option key={item.id} value={item.id}>
                            {item.name}
                          </Select.Option>
                        )
                      })}
                    </Select>
                  )}
                </Item>
              </Col>
            )}
            {isSiYiTeam() && (
              <Col span={12}>
                <Item label="执行人">
                  {getFieldDecorator('emcee_member_id', {
                    // initialValue: '',
                    rules: [
                      {
                        required: true,
                        message: '请选择执行人'
                      }
                    ]
                  })(
                    <MemberSelect
                      showAll={false}
                      style={{ width: '100%' }}
                      reviewedStatus={MEMBER_AUDIT_STATUS.PASSED}
                    />
                  )}
                </Item>
              </Col>
            )}
            {/* slot=5 时，不接单 */}
            {slot != NO_ORDER_TAKING && (
              <>
                <Col span={12}>
                  <Item label="时间">
                    {getFieldDecorator('time')(
                      <TimePicker
                        style={{ width: '100%' }}
                        placeholder="请选择时间"
                        format="HH:mm"
                      />
                    )}
                  </Item>
                </Col>

                <Col span={12}>
                  <Item label="客户姓名">
                    {getFieldDecorator('customerName')(<Input maxLength={8} />)}
                  </Item>
                </Col>

                <Col span={12}>
                  <Item label="电话">
                    {getFieldDecorator('customerPhone', {
                      rules: [
                        {
                          pattern: /^1\d{10}$/,
                          message: '请输入正确的电话'
                        }
                      ]
                    })(<Input />)}
                  </Item>
                </Col>

                <Col span={12}>
                  <Item label="工作地点">
                    {getFieldDecorator('address')(<Input maxLength={30} />)}
                  </Item>
                </Col>

                <Col span={12}>
                  <Item label="合作公司">
                    {getFieldDecorator('company')(<Input maxLength={30} />)}
                  </Item>
                </Col>

                <Col span={12}>
                  <Item label="总价">
                    {getFieldDecorator('actualPrice')(
                      <InputNumber precision={0} min={1} max={1000000} />
                    )}
                  </Item>
                </Col>

                <Col span={12}>
                  <Item label="定金">
                    {getFieldDecorator('deposit')(
                      <InputNumber precision={0} min={1} max={1000000} />
                    )}
                  </Item>
                </Col>

                <Col span={24}>
                  <Item labelCol={{ span: 4 }} wrapperCol label="档期状态">
                    {getFieldDecorator('status', {
                      initialValue: 1
                    })(
                      <Radio.Group>
                        {Object.keys(TYPE_STATUS).map(item => (
                          <Radio value={+item} key={item}>
                            {TYPE_STATUS[item]}
                          </Radio>
                        ))}
                      </Radio.Group>
                    )}
                  </Item>
                </Col>

                <Col span={24}>
                  <Item labelCol={{ span: 4 }} wrapperCol label="备注">
                    {getFieldDecorator('remark')(
                      <Input.TextArea
                        maxLength={500}
                        rows={3}
                        placeholder="请输入备注"
                      />
                    )}
                  </Item>
                </Col>

                <Col span={24}>
                  <Item wrapperCol={{ span: 24 }}>
                    {getFieldDecorator('images')(<Upload max={6} />)}
                  </Item>
                </Col>
              </>
            )}
          </Row>
        </Form>
      </Modal>
    )
  }
}
